import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-22a6fbb5"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["id"];
const _hoisted_2 = {
  class: "cms-form--border"
};
const _hoisted_3 = {
  class: "left-warp"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "cms-data-info-table",
  cellspacing: "0",
  cellpadding: "0"
};
const _hoisted_6 = ["width"];
const _hoisted_7 = {
  key: 0,
  style: {
    "width": "100%"
  }
};
import { nextTick, ref } from 'vue';
import FormItem from '../FormItem/index.vue';
import { useI18n } from 'vue-i18n';
const __default__ = {
  name: "FormTable"
};
export default /*#__PURE__*/_defineComponent({ ...__default__,
  props: {
    col: {
      type: Array,
      default: ['30%', '70%']
    },
    formData: {
      type: Object,
      default: {}
    },
    formList: {
      type: Array,
      default: []
    },
    formatData: {
      type: Function
    },
    // 表单校验对象
    formRules: {
      type: Object,
      default: () => ({})
    },
    c_index: {
      type: Number,
      default: 0
    },
    languageOptions: {
      type: Array,
      default: []
    },
    showBtn: {
      type: Boolean,
      default: true
    }
  },
  emits: ['add-language', 'delete-item', 'search-vod'],

  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const mForm = ref(null);
    expose({
      mForm
    });

    const handleOperation = () => {
      if (props.c_index === 0) {
        emit('add-language');
      } else {
        emit('delete-item', props.c_index);
      }
    };

    const searchVod = index => {
      emit('search-vod', index);
    };

    const releaseDateType = ref('date');
    const releaseDateFormatterObj = reactive({
      'date': 'YYYY-MM-DD',
      'month': 'YYYY-MM',
      'year': 'YYYY'
    });

    const getShortcutsSelect = type => {
      switch (type) {
        case 'date':
          nextTick(() => {
            let dom = document.getElementsByClassName('el-picker-panel__shortcut');
            dom[props.c_index * 3] ? dom[props.c_index * 3].style.color = "#409EFF" : ""; // 高亮显示

            dom[props.c_index * 3 + 1] ? dom[props.c_index * 3 + 1].style.color = "#606266" : ""; // 正常字体颜色

            dom[props.c_index * 3 + 2] ? dom[props.c_index * 3 + 2].style.color = "#606266" : ""; // 正常字体颜色
          });
          break;

        case 'month':
          nextTick(() => {
            let dom = document.getElementsByClassName('el-picker-panel__shortcut');
            dom[props.c_index * 3] ? dom[props.c_index * 3].style.color = "#606266" : "";
            dom[props.c_index * 3 + 1] ? dom[props.c_index * 3 + 1].style.color = "#409EFF" : "";
            dom[props.c_index * 3 + 2] ? dom[props.c_index * 3 + 2].style.color = "#606266" : "";
          });
          break;

        case 'year':
          nextTick(() => {
            let dom = document.getElementsByClassName('el-picker-panel__shortcut');
            dom[props.c_index * 3] ? dom[props.c_index * 3].style.color = "#606266" : "";
            dom[props.c_index * 3 + 1] ? dom[props.c_index * 3 + 1].style.color = "#606266" : "";
            dom[props.c_index * 3 + 2] ? dom[props.c_index * 3 + 2].style.color = "#409EFF" : "";
          });
          break;

        default:
          break;
      }
    };

    const shortcuts = reactive([{
      text: t('按日期'),

      onClick(picker) {
        releaseDateType.value = 'date';
        props.formData.releaseDate = '';
        getShortcutsSelect('date');
      }

    }, {
      text: t('按月份'),

      onClick(picker) {
        releaseDateType.value = 'month';
        props.formData.releaseDate = '';
        getShortcutsSelect('month');
      }

    }, {
      text: t('按年'),

      onClick(picker) {
        releaseDateType.value = 'year';
        props.formData.releaseDate = '';
        getShortcutsSelect('year');
      }

    }]);
    watch(() => props.formData, val => {
      const {
        releaseDate
      } = props.formData;

      if (releaseDate && releaseDate.length == 4) {
        releaseDateType.value = 'year';
        getShortcutsSelect('year');
      } else if (releaseDate && releaseDate.length == 7) {
        releaseDateType.value = 'month';
        getShortcutsSelect('month');
      } else if (releaseDate && releaseDate.length == 10) {
        releaseDateType.value = 'date';
        getShortcutsSelect('date');
      } else {
        getShortcutsSelect(releaseDateType.value);
      }
    }, {
      deep: true,
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      return _openBlock(), _createElementBlock("div", {
        id: 'formGroup-' + __props.c_index,
        style: {
          "margin-bottom": "24px"
        }
      }, [_createElementVNode("header", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        onClick: _cache[0] || (_cache[0] = $event => __props.formData.isShowTable = !__props.formData.isShowTable),
        class: "pointer mg-r--15",
        src: !__props.formData.isShowTable ? require('@/assets/imgs/dropdown.png') : require('@/assets/imgs/dropup.png'),
        alt: ""
      }, null, 8, _hoisted_4), _createVNode(_component_el_form_item, {
        class: "label-language mg-r--20",
        prop: [__props.c_index, 'language'],
        label: _ctx.$t('语言'),
        rules: [{
          required: __props.showBtn ? true : false,
          message: _ctx.$t('请选择语言'),
          trigger: 'change'
        }]
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          filterable: "",
          disabled: !__props.showBtn,
          modelValue: __props.formData.language,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => __props.formData.language = $event),
          class: "m-2",
          placeholder: _ctx.$t('请选择语言'),
          size: "large"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.languageOptions, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              disabled: item.disabled,
              key: item.value,
              label: item.label,
              value: item.code
            }, null, 8, ["disabled", "label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["disabled", "modelValue", "placeholder"])]),
        _: 1
      }, 8, ["prop", "label", "rules"]), __props.showBtn ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        class: "cms-op-btn cms-op-btn--blue--border mg-l--24",
        onClick: _cache[2] || (_cache[2] = $event => searchVod(__props.c_index))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('搜索影片信息')), 1)]),
        _: 1
      })) : _createCommentVNode("", true)]), __props.showBtn ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        class: _normalizeClass([__props.c_index === 0 ? '' : 'delete-btn', "cms-op-btn cms-op-btn-main"]),
        onClick: handleOperation
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.c_index === 0 ? _ctx.$t('新增语言') : _ctx.$t('删除语言')), 1)]),
        _: 1
      }, 8, ["class"])) : _createCommentVNode("", true)]), _withDirectives(_createElementVNode("table", _hoisted_5, [_createElementVNode("colgroup", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.col, c => {
        return _openBlock(), _createElementBlock("col", {
          width: c
        }, null, 8, _hoisted_6);
      }), 256))]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.formList || [], (item, index) => {
        return _openBlock(), _createBlock(FormItem, {
          "form-item": item,
          "form-data": __props.formData,
          "format-data": __props.formatData,
          c_index: __props.c_index
        }, {
          itemSlot: _withCtx(scope => [scope.prop == 'releaseDate' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_date_picker, {
            style: {
              "width": "100%"
            },
            modelValue: __props.formData.releaseDate,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => __props.formData.releaseDate = $event),
            type: releaseDateType.value,
            placeholder: _ctx.$t('请选择时间'),
            shortcuts: shortcuts,
            "value-format": releaseDateFormatterObj[releaseDateType.value]
          }, null, 8, ["modelValue", "type", "placeholder", "shortcuts", "value-format"])])) : _createCommentVNode("", true)]),
          _: 2
        }, 1032, ["form-item", "form-data", "format-data", "c_index"]);
      }), 256))])], 512), [[_vShow, !__props.formData.isShowTable]])], 8, _hoisted_1);
    };
  }

});